import React from "react";
import InscriptionInput from "./InscriptionInput";
import Grades from "./Grades";
import {DegreesBacQuery} from "../apollo/queries/DegreesQuery";
import CiberAlerts, {MESSAGES} from "../util/Messages";
import {calculateAge, getDeviceId} from "../util/Utils";
import {Mutation} from "@apollo/react-components";
import {InscriptionBacNoAffiliateMutation} from "../apollo/mutations/InscriptionMutation";
import ModalDateCorrection from "./ModalDateCorrection";
import DocumentTypes from "./DocumentTypes";
import DatePicker from "react-date-picker";
import Select from "react-select";
import FinalStep from "./FinalStep";
import Spinner from "react-bootstrap/Spinner";
import { BAC_NO_AFFILIATE_INSCRIPTION_URL } from '../constants/urls';
import '../styles/HelpButton.css';
import Footer from "./Footer";
import { IMAGES } from "../util/Messages";


const optionsResponsible = [
  {value: true, label: 'Si'},
  {value: false, label: 'No'},
]

export default class InscriptionFormBacNoAffiliate extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      toInscription: true,
      documentNumber: '',
      documentType: '',
      name: '',
      contactPhone: '',
      contactName: '',
      lastName: '',
      birthDate: '',
      age: '',
      responsibleDocumentNumber: '',
      responsibleDocumentType: '',
      responsibleName: '',
      responsibleLastName: '',
      isResponsible: {
        label: 'Si',
        value: true,
      },
      grade: {
        value: {
          levelId: '',
          programId: '',
          degreeId: '',
        }
      },
      validationCollector:[]
    }
  }

  setError(error) {
    this.setState({
      errorMessage: error
    });
  }

  handleChange = (e, label) => {
    if (label) {
      this.setState({
        [label]: e
      });
    } else {
      this.setState({
        [e.target.name]: e.target.value
      })
    }
  };


  closeModal = () => {
    this.setState({
      showModal: false
    })
  };

  openModal = () => {
    this.setState({
      showModal: true
    })
  };

  onChangeBirthDate = (date) => {
    let age = calculateAge(date)
    if (age < 18) {
      this.setState({
        isResponsible: {
          value: false,
          label: 'No'
        }
      });
    }
    this.setState({
      birthDate: date,
      age: age
    });
  };

  collectValidations = (field, isValid) => {
    this.setState({
      validationCollector: this.state.validationCollector.filter(function (fieldList) {
        return fieldList !== field
      })
    }, () => {
      if (!isValid) {
        this.setState(prevState => ({
          validationCollector: [...prevState.validationCollector, field]
        }))
      }
    });
  }


  isValid = () => {
    return this.state.validationCollector.length === 0 &&
      this.state.name && this.state.lastName && this.state.documentNumber && this.state.documentType.value && this.state.grade.value.levelId && this.state.birthDate &&
      (this.state.isResponsible.value ||
        (!this.state.isResponsible.value && this.state.responsibleName && this.state.responsibleLastName &&
          this.state.responsibleDocumentNumber && this.state.responsibleDocumentType.value));
  }

  render() {
    return (
      <Mutation mutation={InscriptionBacNoAffiliateMutation}
        variables={this.state.toInscription ? {
          dataInscription: {
            affiliateName: this.state.isResponsible.value ? this.state.name : this.state.responsibleName,
            affiliateLastName: this.state.isResponsible.value ? this.state.lastName : this.state.responsibleLastName,
            affiliateDocType: this.state.isResponsible.value ? this.state.documentType.value : this.state.responsibleDocumentType.value,
            affiliateDocument: this.state.isResponsible.value ? this.state.documentNumber : this.state.responsibleDocumentNumber,
            beneficiaryDocType: this.state.documentType.value,
            beneficiaryDocument: this.state.documentNumber,
            beneficiaryName: this.state.name,
            beneficiaryLastName: this.state.lastName,
            levelId: this.state.grade.value.levelId,
            programId: this.state.grade.value.programId,
            degreeId: this.state.grade.value.degreeId,
            birthDate: this.state.birthDate,
            deviceId: getDeviceId()
          }
        } : {
          dataInscription: {
            affiliateName: this.state.isResponsible.value ? this.state.name : this.state.responsibleName,
            affiliateLastName: this.state.isResponsible.value ? this.state.lastName : this.state.responsibleLastName,
            affiliateDocType: this.state.isResponsible.value ? this.state.documentType.value : this.state.responsibleDocumentType.value,
            affiliateDocument: this.state.isResponsible.value ? this.state.documentNumber : this.state.responsibleDocumentNumber,
            beneficiaryDocType: this.state.documentType.value,
            beneficiaryDocument: this.state.documentNumber,
            birthDate: this.state.birthDate,
            beneficiaryName: this.state.name,
            beneficiaryLastName: this.state.lastName,
            contact: this.state.contactName,
            phoneContact: this.state.contactPhone,
            deviceId: getDeviceId()
          }
        }}
        onError={(error) => {
          this.setState({
            errorMessage: error
          })
        }}>
        {(confirmInscription, result) => {
          const {data, loadingSend} = result;

          if (result.data && result.data.saveInscriptionBacNoAffiliate && result.data.saveInscriptionBacNoAffiliate.statusCode === "CIB-GEN-0200") {
            if (result.data.saveInscriptionBacNoAffiliate.redirectUrl) {
              window.location.replace(result.data.saveInscriptionBacNoAffiliate.redirectUrl)
            } else {
              return <FinalStep message={MESSAGES["SUCCESS_BAC"]} title="Inscripcion Cibercolegios"
                internal={true}/>
            }
          }

          const confirmDate = () => {
            this.closeModal();
            this.setState({
              errorMessage: '',
              toInscription: false
            }, () => {
              return confirmInscription()
            });
          };

          return (
            <>
              <div className="card card-signin my-5 col-sm-6 border-left-0 position-relative">
                <div className="card-body">
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <h1 className="card-title text-center mb-0">Inscripción a Cibercolegios</h1>
                    <div className="help-button">
                      <button 
                        className="btn btn-light rounded-circle shadow-sm" 
                        onClick={() => window.open(BAC_NO_AFFILIATE_INSCRIPTION_URL, '_blank')}
                        style={{
                          width: '45px',
                          height: '45px',
                          padding: '0',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          backgroundColor: '#f8f9fa',
                          border: '1px solid #dee2e6',
                          transition: 'all 0.3s ease',
                          marginTop: '-25px',
                          marginRight: '-10px'
                        }}
                      >
                        <i className="fas fa-question-circle" style={{ color: '#0d6efd', fontSize: '1.8rem' }}></i>
                      </button>
                      <div className="tooltip-text">
                        Guía de inscripción
                      </div>
                    </div>
                  </div>
                  {this.state.errorMessage ?
                    <CiberAlerts error={this.state.errorMessage} callBack={this.openModal}/> :
                    null
                  }
                  <br/>
                  <div className="mb-4">
                    <h4 className="font-weight-bold mb-3">Información del aspirante (Estudiante)</h4>
                    <DocumentTypes handleChange={this.handleChange} documentType={this.state.documentType}
                      label="Tipo de documento del aspirante" name="documentType"/>
                    <br/>
                    <InscriptionInput value={this.state.documentNumber} label="N° de documento del aspirante"
                      name="documentNumber" handleChange={this.handleChange} validation="number" collectValidations={this.collectValidations}/>
                    <InscriptionInput value={this.state.name} label="Nombres del aspirante" name="name"
                      handleChange={this.handleChange} validation="text" collectValidations={this.collectValidations}/>
                    <InscriptionInput value={this.state.lastName} label="Apellidos del aspirante" name="lastName"
                      handleChange={this.handleChange} validation="text" collectValidations={this.collectValidations}/>
                    <label>Fecha de Nacimiento</label><br/>
                    <DatePicker onChange={this.onChangeBirthDate} value={this.state.birthDate}
                      maxDate={new Date()}/>
                    <br/>
                    <br/>
                    <InscriptionInput value={this.state.age} label="Edad" readOnly={true}/>
                    <Grades grade={this.state.grade} service={DegreesBacQuery} variables={{}}
                      index="degreesBac" handleChange={this.handleChange}
                    />
                  </div>                  
                  <label>¿El aspirante es responsable del pago?</label>
                  <Select options={optionsResponsible} value={this.state.isResponsible} isDisabled={this.state.age<18}
                    onChange={e => this.handleChange(e, 'isResponsible')}/>
                  {!this.state.isResponsible.value ?
                    <>
                      <br/>
                      <br/>
                      <div className="mb-4">
                        <h4 className="font-weight-bold mb-3">Información del responsable de pago</h4>
                        <DocumentTypes handleChange={this.handleChange} documentType={this.state.responsibleDocumentType}
                          label="Tipo de Documento del responsable de pago" name="responsibleDocumentType"/>
                        <br/>
                        <InscriptionInput value={this.state.responsibleDocumentNumber}
                          label="N° de documento del responsable de pago" name="responsibleDocumentNumber"
                          handleChange={this.handleChange} validation="number" collectValidations={this.collectValidations}/>
                        <InscriptionInput value={this.state.responsibleName} label="Nombres del responsable de pago"
                          name="responsibleName" handleChange={this.handleChange} validation="text" collectValidations={this.collectValidations}/>
                        <InscriptionInput value={this.state.responsibleLastName} handleChange={this.handleChange}
                          label="Apellidos del responsable de pago" name="responsibleLastName" validation="text" collectValidations={this.collectValidations}/>
                        <br/>
                      </div>
                    </> : <><br/></>
                  }
                  <button className="btn btn-lg btn-primary btn-block" type="button"
                    onClick={confirmInscription}
                    disabled={!this.isValid()}
                  >
                    Diligenciar Inscripción {result.loading ? <Spinner animation="border" role="status">
                    <span className="sr-only">Loading...</span>
                  </Spinner> : ""}
                  </button>
                  <Footer footer={IMAGES.footerColsubsidio} />
                  <ModalDateCorrection
                    show={this.state.showModal}
                    handleClose={this.closeModal}
                    date={this.state.birthDate}
                    onChange={this.onChangeBirthDate}
                    callBack={confirmDate}
                    withContactInfo={true}
                    contactName={this.state.contactName}
                    contactPhone={this.state.contactPhone}
                    onChangeContact={this.handleChange}
                  />
                </div>
              </div>
            </>
          )
        }}
      </Mutation>
    )
  }
}
